import { themeColors } from '@/styles/theme';
import React from 'react';

const ReportsAnalyticsIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className || "w-6 h-6"}
  >
    <path d="M18 20V10" stroke={themeColors.iconMuted} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 20V4" stroke={themeColors.iconMuted} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 20V14" stroke={themeColors.iconMuted} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default ReportsAnalyticsIcon;
